const BASIC_SOAP = [
    { id: "a", name: "Basic SOAP" },
    { id: "b", name: "Simple SOAP" },
    { id: "c", name: "Standard SOAP" }
];

const TYPE = {
    ALL: 0,
    BUNDLE: 1,
    CONTENT_SNIPPET: 4,
    MEDICAL_NOTE: 5,
    LETTER: 6,
    WELLNESS_PLAN: 7,
    CUSTOM_FIELD: 8,
    ATTACHMENT: 9,
    PURCHASE_ORDER: 10,
    BUNDLE_ESTIMATE: 11,
    WEBFORM_TEMPLATE: 12
};

const IN_VIEW = [
    TYPE.PURCHASE_ORDER,
    TYPE.WEBFORM_TEMPLATE,
    TYPE.CONTENT_SNIPPET,
    TYPE.LETTER,
    TYPE.MEDICAL_NOTE,
    TYPE.BUNDLE,
    TYPE.BUNDLE_ESTIMATE,
    TYPE.WELLNESS_PLAN
];

// register template that using modal-delete-template.vue
const IN_VIEW_DELETE_MODAL = [
    TYPE.PURCHASE_ORDER,
    TYPE.WEBFORM_TEMPLATE,
    TYPE.CONTENT_SNIPPET,
    TYPE.LETTER
];

const IN_VIEW_SAVE_EDIT_USE_BARRAMUNDI = [TYPE.LETTER, TYPE.CONTENT_SNIPPET];

const LIST = {
    [TYPE.ALL]: {
        label: "All",
        label_dropdown: "All Templates",
        route: "all"
    },
    [TYPE.BUNDLE]: {
        label: "Bundle (Invoice)",
        label_dropdown: "Bundles (Invoices)",
        route: "bundle"
    },
    [TYPE.CONTENT_SNIPPET]: {
        label: "Snippet",
        label_dropdown: "Snippets",
        route: "content-snippet"
    },
    [TYPE.MEDICAL_NOTE]: {
        label: "Medical Note",
        label_dropdown: "Medical Notes",
        route: "medical-note"
    },
    [TYPE.LETTER]: {
        label: "Letter",
        label_dropdown: "Letters",
        route: "letter"
    },
    [TYPE.WELLNESS_PLAN]: {
        label: "Wellness Plan",
        label_dropdown: "Wellness Plans",
        route: "wellness-plan"
    },
    [TYPE.CUSTOM_FIELD]: {
        label: "Custom Field",
        label_dropdown: "Custom Fields",
        route: "custom-field"
    },
    [TYPE.ATTACHMENT]: {
        label: "Attachment",
        label_dropdown: "Attachments",
        route: "attachment"
    },
    [TYPE.PURCHASE_ORDER]: {
        label: "Purchase Order",
        label_dropdown: "Purchase Orders",
        route: "purchase-order"
    },
    [TYPE.BUNDLE_ESTIMATE]: {
        label: "Bundle (Estimate)",
        label_dropdown: "Bundles (Estimates)",
        route: "bundle-estimate"
    },
    [TYPE.WEBFORM_TEMPLATE]: {
        label: "Form",
        label_dropdown: "Forms",
        route: "form"
    }
};

const ACTIVITY_TYPE = {
    MEDICAL: 1,
    VITALS: 2,
    OTHER: 3
};

const ACTIVITY_TYPE_STR = {
    [ACTIVITY_TYPE.MEDICAL]: "Medical",
    [ACTIVITY_TYPE.VITALS]: "Vitals",
    [ACTIVITY_TYPE.OTHER]: "Other"
};

const ACTION_WARNING_MESSAGE = [
    "Can not create reminder on item.",
    "Cannot create action on item.",
    "Reminder action already exist.",
    "Can not create reminder on item.",
    "Form for this item already exist.",
    "Letter for this item already exist."
];

const PRODUCTION_CREDIT_TYPE = {
    NO_CREDIT: 1,
    ENROLLMENT_CREDIT: 2,
    SERVICE_CREDIT: 3
};

export default {
    BASIC_SOAP,
    TYPE,
    LIST,
    IN_VIEW,
    IN_VIEW_DELETE_MODAL,
    IN_VIEW_SAVE_EDIT_USE_BARRAMUNDI,
    ACTIVITY_TYPE,
    ACTIVITY_TYPE_STR,
    ACTION_WARNING_MESSAGE,
    PRODUCTION_CREDIT_TYPE
};
